import type { FaireProductEntity } from "../../entity_types/product";

export const p_x8ej7skbqk: FaireProductEntity = {
  token: "p_x8ej7skbqk",
  type: "product",
  name: "woodland notecard",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/ebdfed1beb6c3b261409bcbc20aac2e2a59492ef4b30133e5d4c241f3a5a00dc.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e50d1af23b3e6d1861ea1464b9c80b76651e9a74f51ed900ce540549d8e9b0f2.jpeg",
  ],
  priceDollars: 8,
  description:
    'Send sweet greetings to your loved ones. The woodland notecards are blank on the inside with charming watercolor illustrations on the front. Bring beauty to your thank-you notes, housewarming gifts, get-well wishes, and more.\n\n𝐃𝐞𝐭𝐚𝐢𝐥𝐬:\n\n• set of eight folded cards + envelopes\n• blank inside\n• 5.5" x 4.25"\n• Printed on 120lb superfine paper\n• Original watercolor artwork by Emily Lex',
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:14:53.132Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
